import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-24">
      <section className="py-20 bg-surface">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl font-serif font-bold text-primary tracking-tight mb-6">
            Privacybeleid
          </h1>
          <p className="text-sm text-muted-foreground">
            Laatst bijgewerkt: Januari 2026
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6 space-y-8 text-muted-foreground leading-relaxed">
          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              1. Introductie
            </h2>
            <p>
              4AN Hair & Beauty Studio ("wij", "ons") respecteert uw privacy en is toegewijd aan het
              beschermen van uw persoonlijke gegevens. Dit privacybeleid legt uit hoe we uw
              persoonlijke informatie verzamelen, gebruiken en beschermen wanneer u onze diensten
              gebruikt of een afspraak maakt.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              2. Welke Gegevens Verzamelen We?
            </h2>
            <p>We verzamelen de volgende persoonlijke gegevens:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Naam</li>
              <li>E-mailadres</li>
              <li>Telefoonnummer</li>
              <li>Afspraakgeschiedenis</li>
              <li>Voorkeuren en allergieën (indien verstrekt)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              3. Hoe Gebruiken We Uw Gegevens?
            </h2>
            <p>Uw persoonlijke gegevens worden gebruikt voor:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Het beheren en bevestigen van afspraken</li>
              <li>Het versturen van herinneringen voor afspraken</li>
              <li>Het leveren van de best mogelijke service</li>
              <li>Het versturen van promotionele aanbiedingen (alleen met uw toestemming)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              4. Marketing Toestemming
            </h2>
            <p>
              We versturen alleen marketingcommunicatie naar klanten die expliciet toestemming hebben
              gegeven. U kunt deze toestemming op elk moment intrekken door contact met ons op te
              nemen of via de afmeldlink in onze e-mails.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              5. Uw Rechten (AVG)
            </h2>
            <p>Onder de AVG heeft u de volgende rechten:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Recht op toegang tot uw persoonlijke gegevens</li>
              <li>Recht op rectificatie van onjuiste gegevens</li>
              <li>Recht op verwijdering ("recht om vergeten te worden")</li>
              <li>Recht op beperking van verwerking</li>
              <li>Recht op gegevensoverdraagbaarheid</li>
              <li>Recht om bezwaar te maken tegen verwerking</li>
            </ul>
            <p className="mt-4">
              Om een van deze rechten uit te oefenen, neem contact met ons op via info@4anhair.com.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              6. Gegevensbeveiliging
            </h2>
            <p>
              We nemen passende technische en organisatorische maatregelen om uw persoonlijke
              gegevens te beschermen tegen ongeoorloofde toegang, verlies of wijziging.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              7. Bewaartermijn
            </h2>
            <p>
              We bewaren uw persoonlijke gegevens niet langer dan noodzakelijk voor de doeleinden
              waarvoor ze zijn verzameld, tenzij een langere bewaartermijn wettelijk vereist is.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif font-semibold text-primary mb-4">
              8. Contact
            </h2>
            <p>
              Voor vragen over dit privacybeleid of het uitoefenen van uw rechten, kunt u contact
              met ons opnemen:
            </p>
            <p className="mt-2">
              <strong>4AN Hair & Beauty Studio</strong><br />
              Alfonse de cockplein 5A, 1831 Diegem<br />
              E-mail: info@4anhair.com<br />
              Telefoon: +32 473 18 39 27
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
